import {GalleryBlock} from "../../blocks/gallery/GalleryBlock";
import {API, Entities} from "../../utils/Api";
import {useLoaderData} from "react-router-dom";
import {CenterHero} from "../../blocks/hero/Hero";

export default function GalleryPage(){
    const data= useLoaderData();
    const gallery= data.gallery;
    const years = data.years;

    console.log(data)
    return(
        <>
        <CenterHero megaphone={'Minden kép egy helyen'} titles={['Galéria']}
                    url={'/benefitshare/img/headerbg3.jpg'}></CenterHero>
        <GalleryBlock yearsData={years} galleryData={gallery}></GalleryBlock>
        </>
            )
}

export async function GalleryPageLoader(){
    var years;
    try {
        const response = await API.rest(Entities.galleryYears, "GET"); // Várjuk meg az API választ
        years = response;
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { gallery: [],years:[]}; // Hiba esetén üres tömböt adunk vissza
    }

    try {
        const response = await API.rest(Entities.gallery, "GET",{},years[0]); // Várjuk meg az API választ
        return{
            gallery: response,
            years:years
        };
    } catch (error) {
        console.error("Hiba történt az API hívás során:", error);
        return { gallery: [],years:[]}; // Hiba esetén üres tömböt adunk vissza
    }

}